const ATC_EVENT = "shop_add_to_cart";
const VIEW_EVENT = "shop_view";
const getAddToCartEventTracking = (sku, quantity) => ({
  tealium_event: ATC_EVENT,
  singleSku: sku,
  singleSkuQuantity: quantity
});
const getProductViewEventTracking = (sku) => ({
  tealium_event: VIEW_EVENT,
  singleSku: sku
});
export {
  ATC_EVENT,
  VIEW_EVENT,
  getAddToCartEventTracking,
  getProductViewEventTracking
};
//# sourceMappingURL=event-tracking.mjs.map
